import React, { useEffect, useRef } from 'react'
import { dashboard } from '../../../../Common/data/mobileView/Dashboard'

import topIconSetLight from '../../../../../src/assets/images/app_header_top_iconset.png';

import user from '../../../../../src/assets/images/user.png'
import search from '../../../../../src/assets/images/app_search_icon.png'
import menu from '../../../../../src/assets/images/app_menu_icon.png'
import userImg from '../../../../../src/assets/images/lumi_img.jpg'

import locationIcon from '../../../../../src/assets/images/app_location_icon.png'

import locationIconWhite from '../../../../../src/assets/images/app_location_icon_white.png'
import { useSelector } from 'react-redux';
import Log from '../../../../Services/Log';
import { Spin } from 'antd';

// import { useDispatch, useSelector } from 'react-redux'
// import { getMobileData } from '../../../../slices/mobile-view/thunk';
// import { Spin } from 'antd';

const DashboardView = ({ children, currentTime, data, className }) => {
    const scrollableContentRef = useRef(null);
    let content = data.dashboard;
    let dashboardData = useSelector((state) => state.MobileViewDashboard?.data);
    let advertisementRef = useRef();
    let scrollableAreaRef = useRef();

    // Normalize height display to "Xft Y in" (strip cm part if present)
    const formatHeight = (height) => {
        if (!height) return null;
        const label = typeof height === 'object' ? (height.label || height.value || height.name || height.code) : height;
        if (!label || typeof label !== 'string') return null;

        let text = label.trim();

        // If format like "126 cm / 4 ft 2 in" -> take part after '/'
        if (text.includes('/')) {
            const parts = text.split('/');
            text = parts[parts.length - 1].trim();
        }

        // If format like 5'6" -> convert to 5ft 6 in
        const feetInchesMatch = text.match(/^(\d+)\s*'\s*(\d+)\s*"?$/);
        if (feetInchesMatch) {
            const [, ft, inch] = feetInchesMatch;
            return `${ft}ft ${inch} in`;
        }

        // If already like "4 ft 2 in" -> normalize spacing to Xft Y in
        const imperialMatch = text.match(/(\d+)\s*ft\s*(?:([0-9]{1,2})\s*in)?/i);
        if (imperialMatch) {
            const ft = imperialMatch[1];
            const inch = imperialMatch[2];
            return inch !== undefined ? `${ft}ft ${inch} in` : `${ft}ft`;
        }

        // Fallback: remove any trailing cm portion if provided first
        const cmRemoved = text.replace(/\b\d+\s*cm\b.*$/i, '').trim();
        return cmRemoved || text;
    };

    useEffect(() => {
        if (scrollableAreaRef.current) {
            scrollableAreaRef.current.scrollTo({
                top: scrollableAreaRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    }, )


    return (
        <>
            {
                dashboardData.loading && (
                    <div className="spinner center">
                        <Spin />
                    </div>
                )
            }
            {
                content && (
                    <div className='app '>
                        <div className={`app mobile_dashboard ${className} demo_text_added  `} ref={scrollableAreaRef}>
                            <div className='scrollable_arrow' >
                                <header className="app__header">
                                    <div className="app__header__top">
                                        {
                                            currentTime && (
                                                <span className="app__header__top__time">{currentTime}</span>
                                            )
                                        }
                                        <div className="app__header__top__icons">
                                            <img src={topIconSetLight} alt="" />
                                        </div>
                                    </div>
                                    <div className="app__header__bottom" >
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <span><img src={user} alt="" /></span>
                                            <div className='app_greeting_block'>
                                                <span className="app__header__bottom__greeting">{dashboard[0].header.greeting}</span>
                                                <span className="app_header_user">{dashboard[0].header.name}</span>
                                            </div>
                                        </div>
                                        <div className='app__icon_wrap'>
                                            <ul>
                                                <li><img src={search} alt="" /></li>
                                                <li><img src={menu} alt="" /></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="app__main__section app__main__section--profile" style={{ flexDirection: "row" }}>
                                        <div className="app__profile_wrap">
                                            <div className="app__main__section__card__header">
                                                <span className="app__main__section__card__header__count">{dashboard[0].profile.shortlistedProfiles}</span>
                                                <span className="app__main__section__card__header__title text-center">Shortlisted Profiles</span>
                                            </div>
                                        </div>
                                        <div className="app__profile_wrap">
                                            <div className="app__main__section__card__header">
                                                <span className="app__main__section__card__header__count">{dashboard[0].profile.recentlyViewed}</span>
                                                <span className="app__main__section__card__header__title text-center">Recently Viewed</span>
                                            </div>
                                        </div>
                                        <div className="app__profile_wrap">
                                            <div className="app__main__section__card__header">
                                                <span className="app__main__section__card__header__count">{dashboard[0].profile.profileVisitors}</span>
                                                <span className="app__main__section__card__header__title text-center">Profile Visitors</span>
                                            </div>
                                        </div>
                                        <div className="app__profile_wrap">
                                            <div className="app__main__section__card__header">
                                                <span className="app__main__section__card__header__count">{dashboard[0].profile.buyContacts}</span>
                                                <span className="app__main__section__card__header__title text-center">Credits to Buy Contacts</span>
                                            </div>
                                        </div>
                                    </div>
                                </header>
                                <main className="app__main">
                                    <section className=" app__main__section--newMatches">
                                        <div className="app__title_wrap">
                                            <h2 className="app__main__section__title text_red">
                                                {content[0]?.title}
                                            </h2>
                                            <span className='text_dark'>View All</span>
                                        </div>
                                        <div className="app__main__section__cards">
                                            {
                                                content[0]?.profile_list?.map((el, index) => {
                                                    return (
                                                        <div key={index} className="app__main__section__card">
                                                            <div className='img_holder_sm'>
                                                                <img src={el.profile_images[0].thumbnail} alt="" />
                                                            </div>
                                                            <div className="app__main__section__card__info">
                                                                <span className="app__main__section__card__info__name">{el.name}</span>
                                                                <span className="app__main__section__card__info__age">{el.age} <span className='text_red'>|</span> {formatHeight(el.height) || '5ft 6 in'}</span>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }

                                            {/* <div key={index} className="app__main__section__card">
                                    <div className="app__main__section__card__info">
                                        <span className="app__main__section__card__info__name">{match.name}</span>
                                        <span className="app__main__section__card__info__age">{match.age} <span className='text_red'>|</span> {match.height}</span>
                                    </div>
                                </div> */}
                                        </div>
                                    </section>
                                    <section className="app__main__section app__main__section--discoverPartner text-center">
                                        <h2 className="app__main__section__title fw_light">{content[1]?.title}</h2>
                                        <div className="app__main__section__cards app__partner__grid">
                                            {content[1]?.icon_list?.map((key, index) => (
                                                <div key={index} className="app__main__section__card">
                                                    {/* <span className="app__main__section__card__icon app__main__section__card__icon--{key}">
                            <img src={`./images/${dashboard[0].discoverPartnerBy[key]}.png`} alt={dashboard[0].discoverPartnerBy[key]} />
                        </span> */}
                                                    <span className="app__main__section__card__icon app__main__section__card__icon--{key}">
                                                        <img src={key.icon} alt={index} />
                                                    </span>
                                                    <span className="app__main__section__card__title">{key.filter_type}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </section>
                                    <section className="app__main__section mt app__main__section--nearbyProfiles" style={{ display: "block" }}>
                                        <div className="app__title_wrap">
                                            <h2 className="app__main__section__title text_red">
                                                {content[2]?.title}
                                            </h2>
                                            <span className='text_dark'>View All</span>
                                        </div>
                                        <div className="app__main__section__cards">
                                            <div className="app__main__section__cards" style={{ flexWrap: 'unset' }}>

                                                {
                                                    content[2]?.profile_list?.map((el, index) => {
                                                        return (
                                                            <div key={index} className="app__main__section__card">
                                                                <div>
                                                                    <div className="img_holder_sm">
                                                                        <img src={el.profile_images[0].thumbnail} alt={index} />
                                                                    </div>
                                                                    <span className='app__distance'>
                                                                        <span><img src={locationIconWhite} alt="" /> <span>{el.distance}</span></span>
                                                                    </span>
                                                                </div>
                                                                <div className="app__main__section__card__info">
                                                                    <span className="app__main__section__card__info__name">{el.name}</span>
                                                                    <span className="app__main__section__card__info__age">{el.age} <span className='text_red'>|</span> {formatHeight(el.height) || '5ft 6 in'}</span>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                {dashboard[0].nearbyProfiles.profiles.map((match, index) => (
                                                    <div key={index} className="app__main__section__card">
                                                        <div>
                                                            <img src={userImg} alt={match.name} />
                                                            <span className='app__distance'>
                                                                <span><img src={locationIconWhite} alt="" /> <span>{match.distance}</span></span>
                                                            </span>
                                                        </div>
                                                        <div className="app__main__section__card__info">
                                                            <span className="app__main__section__card__info__name">{match.name}</span>
                                                            <span className="app__main__section__card__info__age">{match.age} <span className='text_red'>|</span> {match.height}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </section>
                                    <section className="app__main__section app__main__section--advertisement" style={{ marginBottom: '12px', marginTop: 0 }} ref={advertisementRef}>
                                        {children}
                                    </section>
                                    <section className="app__main__section app__main__section--recentVisitors" style={{ display: "block" }}>
                                        {/* <div className="app__title_wrap">
                                    <h2 className="app__main__section__title text_red">
                                        {content[5]?.title}
                                    </h2>
                                    <span className='text_dark'>View All</span>
                                </div> */}
                                        <div className="app__main__section__cards full_grid">
                                            {content[5]?.profile_list?.map((el, index) => (
                                                <div key={index} className="app__main__section__card ">
                                                    {/* <img src={`./images/${visitor.image}.jpg`} alt={visitor.name} /> */}
                                                    <div className='img_holder_xsm'>
                                                        <img src={el.profile_images[0].thumbnail} alt="" />
                                                    </div>
                                                    <div className="app__main__section__card__info mt_0">
                                                        <span className="app__main__section__card__info__name">{el.name}</span>
                                                        <span className="app__main__section__card__info__age">{el.age} <span className='text_red divider'>|</span> {el.marital_status?.label} <span className='text_red divider'>|</span> {el.job?.label} <span className='text_red divider'>|</span> {formatHeight(el.height) || '5ft 6 in'}</span>
                                                        <span className="app__main__section__card__info__location">{el.location}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </section>
                                    <section className="app__main__section app__main__section--todayMatches">
                                        <div className="app__main__section__cards demo">
                                            {
                                                content[3]?.filter_list?.map((el, index) => {
                                                    return (
                                                        <button key={index} className="app__main__section__card app__main__section__card--todayMatches">{el.title}</button>
                                                    )
                                                })
                                            }
                                        </div>
                                    </section>
                                    <section className="app__main__section app__main__section--recommendedProfiles">
                                        <h2 className="app__main__section__title">{content[6]?.title}</h2>
                                        <div className="app__main__section__cards short">
                                            {content[6]?.profile_list?.map((el, index) => (
                                                <div key={index} className="app__main__section__card">
                                                    {/* <img src={`./images/${profile.image}.jpg`} alt={profile.name} /> */}
                                                    <div className='img_holder_xsm'>
                                                        <img src={el.profile_images[0].thumbnail} alt="" />
                                                    </div>
                                                    <div className="app__main__section__card__info">
                                                        <span className="app__main__section__card__info__name">{el.name}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </section>
                                </main>
                            </div>
                        </div>
                    </div>
                )
            }

        </>

    )
}

export default DashboardView